var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQueryActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1577_3888",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 34,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 20V7.5C35 6.83696 34.7366 6.20107 34.2678 5.73223C33.7989 5.26339 33.163 5 32.5 5H7.5C6.83696 5 6.20107 5.26339 5.73223 5.73223C5.26339 6.20107 5 6.83696 5 7.5V32.5C5 33.163 5.26339 33.7989 5.73223 34.2678C6.20107 34.7366 6.83696 35 7.5 35H20",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.668 31.667C29.4294 31.667 31.668 29.4284 31.668 26.667C31.668 23.9056 29.4294 21.667 26.668 21.667C23.9065 21.667 21.668 23.9056 21.668 26.667C21.668 29.4284 23.9065 31.667 26.668 31.667Z",
    fill: "#555555",
    stroke: "white",
    strokeWidth: 3.33333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8346 29.9997L35.0013 33.333M11.668 13.333H28.3346M11.668 19.9997H18.3346",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1577_3888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0V0Z",
    fill: "#399E79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryActive);
export default __webpack_public_path__ + "static/media/queryActive.89741ebc73c36ba462440caf04211ea1.svg";
export { ForwardRef as ReactComponent };